export const VERDICT_BADGE_BASE =
	'inline-flex items-center gap-3xs rounded-full px-2xs py-3xs text-[10px] font-medium tabular-nums';

export const VERDICT_BADGE_PASS = 'bg-green-50 text-success';
export const VERDICT_BADGE_FAIL = 'bg-red-50 text-error';
export const VERDICT_BADGE_NEUTRAL = 'bg-grey-25 text-subtle';
